import { render, staticRenderFns } from "./DataAnalysis.vue?vue&type=template&id=0af61d1e&scoped=true&"
import script from "./DataAnalysis.vue?vue&type=script&lang=js&"
export * from "./DataAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./DataAnalysis.vue?vue&type=style&index=0&id=0af61d1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af61d1e",
  null
  
)

export default component.exports